import themeVariables from "@Theme/exportColor.module.scss";

export default ({ fill = themeVariables.neutral1, width = "3" }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 3 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" fill={fill} />
  </svg>
);
